module.exports = "<template dynamic-component \r\n                  (dynamicComponentReady)=\"finishTemplateLoading()\"\r\n                  [componentModules]=\"dynamicExtraModules\"\r\n                  [componentTemplate]=\"content\" \r\n                  [componentContext]=\"self\" #container>\r\n</template>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/workflows/content-renderer/content-renderer.component.html
// module id = 730
// module chunks = 1 2